export default __webpack_public_path__ + "static/media/O-060.6f6552fd.png";